import { render, staticRenderFns } from "./Variationdetails.vue?vue&type=template&id=a8a1d216&scoped=true"
import script from "./Variationdetails.vue?vue&type=script&lang=js"
export * from "./Variationdetails.vue?vue&type=script&lang=js"
import style0 from "./Variationdetails.vue?vue&type=style&index=0&id=a8a1d216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a1d216",
  null
  
)

export default component.exports